import { ITheme } from "../../utils/theme";

export const inputStyle = {
  minHeight: '5rem',
}

export const messageStyle = (theme: ITheme) => ({
  color: theme.palette.red['850'],
  background: theme.palette.red['350'],
  padding: 4
});